<div class="page-padding">
  <h1 class="header-text">{{'resetPassword.reset_password' | translate}}</h1>
  <p class="mobile-number-text">{{'resetPassword.pick' | translate}}</p>
  <form [formGroup]="resetPasswordForm">
    <ion-item
      lines="none"
      [ngClass]="
        resetPasswordForm.get('password').touched && resetPasswordForm.get('password')?.errors ? 'invalid-field' : ''
      "
      >
      <ion-input
        [type]="passwordType"
        clearOnEdit="false"
        formControlName="password"
        placeholder="{{ 'resetPassword.new-placeholder' | translate }}"
        class="password-desk signupfield password-alignment"
        maxlength="20"
        minlength="6"
      ></ion-input>
      @if (passwordIcon === 'eye-off') {
        <img
          class="password-reveal-icon"
          src="assets/icon/eye.svg"
          (click)="toggleViewPassword()"
          alt="eye-on"
          />
      }
      @if (passwordIcon === 'eye') {
        <img
          class="password-reveal-icon"
          src="assets/icon/eye-off.svg"
          (click)="toggleViewPassword()"
          alt="eye-off"
          />
      }
    </ion-item>
    @if (resetPasswordForm.get('password').touched && resetPasswordForm.get('password')?.errors?.minlength) {
      <div
        class="errorContainer"
        >
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{'resetPassword.mismatch_password' | translate}}</span>
      </div>
    }
    @if (resetPasswordForm.get('password').touched && resetPasswordForm.get('password')?.errors?.required) {
      <div
        class="errorContainer"
        >
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{'resetPassword.enter_password' | translate}}</span>
      </div>
    }

    <ion-item
      lines="none"
      [ngClass]="
        resetPasswordForm.get('confirmPassword').touched && resetPasswordForm.get('confirmPassword')?.errors
          ? 'invalid-field'
          : ''
      "
      >
      <ion-input
        [type]="passwordTypeConfirm"
        clearOnEdit="false"
        formControlName="confirmPassword"
        placeholder="{{ 'resetPassword.conf-placeholder' | translate }}"
        class="password-desk signupfield password-alignment"
        maxlength="20"
        minlength="6"
      ></ion-input>
      @if (passwordIconConfirm === 'eye-off') {
        <img
          class="password-reveal-icon"
          src="assets/icon/eye.svg"
          (click)="toggleViewPasswordConfirm()"
          alt="eye-on"
          />
      }
      @if (passwordIconConfirm === 'eye') {
        <img
          class="password-reveal-icon"
          src="assets/icon/eye-off.svg"
          (click)="toggleViewPasswordConfirm()"
          alt="eye-off"
          />
      }
    </ion-item>
    @if (
      resetPasswordForm.get('confirmPassword').touched && resetPasswordForm.get('confirmPassword')?.errors?.required
      ) {
      <div
        class="errorContainer"
        >
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{'resetPassword.re_enter_password' | translate}}</span>
      </div>
    }
    @if (
      resetPasswordForm.get('confirmPassword').touched &&
      resetPasswordForm.get('confirmPassword')?.errors?.passwordMismatch
      ) {
      <div
        class="errorContainer"
        >
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{'resetPassword.mismatch_password' | translate}}</span>
      </div>
    }

    <ion-button
      [disabled]="resetPasswordForm.invalid"
      (click)="onPasswordResetSubmit(); startSpinner()"
      class="update-btn"
      >
      @if (!spinnerAnimation && proceed) {
        <span>{{'resetPassword.reset' | translate}}</span>
      }
      @if (spinnerAnimation) {
        <div class="spinners">
          <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40"></mat-progress-spinner>
          <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
          </mat-progress-spinner>
        </div>
      }
      @if (!proceed) {
        <mat-icon [@bounceIn] class="tick-mark">
          <svg xmlns="http://www.w3.org/2000/svg" height="60" viewBox="0 96 960 960" width="60"><path d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z"/></svg>
        </mat-icon>
      }
    </ion-button>
  </form>
  <p class="link-text-blue" (click)="dismissDialog()">{{'resetPassword.back_to_login' | translate}}</p>
</div>
